import { render } from "./DashboardQuotesTable.vue?vue&type=template&id=16cf46f4&scoped=true"
import script from "./DashboardQuotesTable.vue?vue&type=script&lang=js"
export * from "./DashboardQuotesTable.vue?vue&type=script&lang=js"

import "./DashboardQuotesTable.vue?vue&type=style&index=0&id=16cf46f4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16cf46f4"]])

export default __exports__